// extracted by mini-css-extract-plugin
export default {"FixedContainer":"FixedContainer_nYYrd","TopLeft":"TopLeft_m1iIU","TopRight":"TopRight_A2bWO","BottomCenter":"BottomCenter_oTBMp","TopCenter":"TopCenter_IKSkK"};